import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';

const BLUEPRINT_URL = `${fixProtocol(Constants.BACKEND_URL)}/activity-executions/`;

export const getLastActivityExecution = async () => {
  const url = new URL(BLUEPRINT_URL + 'get-last-activity-execution');

  return httpGet(url.href)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error('Error getting last activity execution', error);
    });
};
